import Backbone from 'backbone';

const AbstractItem = Backbone.View.extend({
    
    attributes:{
      'tabindex': '0'
    },
    
    events: {
      'dblclick': 'doubleClick',
      'click': 'onClick',
      'keyup': 'onKeyUp',
      'keydown': 'onKeyDown'
    },    
    
    _initializeBaseListeners: function(){
      this.listenTo(this.model, 'change', this.render);
      this.listenTo(this.model, 'destroy', function(){
        this.fadeOut();
      }); 
    },
        
    _bindDragging: function(helperFn){
      var dragOptions = {
        containment: 'window',
        revert: 'invalid',
        zIndex: 10000,
        scroll: true,
        start: function(e, ui) {
          if(ui.helper.hasClass('multiple-drag-items')){
            ui.helper.css({
              'margin-top': (e.pageY - ui.offset.top) - 30,
              'margin-left': (e.pageX - ui.offset.left) - 30
            });
          }
          ui.helper.data('startingScrollTop', $('.file-items').scrollTop());
          $('.file-items').animate({
            scrollTop: 0
          }, 200);
        },
        stop: function(e, ui){
          $('.file-items').animate({
            scrollTop: ui.helper.data('startingScrollTop')
          }, 200);
        }
      };
      if (helperFn){
        dragOptions.helper = helperFn;
      }
      this.$el.draggable(dragOptions);
    },

    doubleClick: function(e) {
      if(!e.shiftKey){
        this.trigger('dblclick', this.model);
      }
    },
    
    onKeyDown: function(e){
      if (e.keyCode == 32){
        e.preventDefault();
        e.stopPropagation();
        this.trigger('space-pressed', this.model);
      }
    },
    
    onKeyUp: function(e){
      if(e.keyCode == 13){
        e.preventDefault();
        e.stopPropagation();
        this.trigger('return-pressed', this.model);
      }
    },
    
    onClick: function(e) {
      e.stopPropagation();
      if (e.shiftKey){
        this.shiftClickHandler(e);
      } else if(e.metaKey || e.ctrlKey){
        this.cmdClickHandler(e);
      } else{
        this.clickHandler(e);
      }
    },
    
    clickHandler: function(e){
      this.trigger('click', this.model);
    },
    
    cmdClickHandler: function(e){
      this.trigger('command-click', this.model);
    },
    
    shiftClickHandler: function(){
      this.trigger('shift-click', this.model);
    },
    
    fadeOut: function(){
      var me = this;
      me.$el.fadeOut(400, function(){
        me.remove();
        me.trigger('removed');
      });
    }
    
  });
 
 export default AbstractItem;